<template>
  <div class="center">
    <br/>
    <br/>
    <br/>
    <ion-spinner name="crescent"></ion-spinner>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
  </div>
</template>

<script>
import {IonSpinner} from '@ionic/vue'
export default {
  name: "Loading",
  components:{
    IonSpinner,
  }
}
</script>

<style scoped>
ion-spinner{
  font-size: 18px;
}
</style>